import { atom } from 'jotai';
import { $CurrentGalleryArticle, $CurrentGallerySlide } from '.';

export const $LabelSwitcherVisible = atom((get) => {
  const { galleryLabels } = get($CurrentGalleryArticle);
  const currentGallerySlide = get($CurrentGallerySlide);

  const currentSlideLabels = galleryLabels.filter((g) => g.imageIndex === currentGallerySlide);

  return Boolean(currentSlideLabels.length);
});
